/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditFeatureRequest
 */
export interface EditFeatureRequest {
    /**
     * 
     * @type {string}
     * @memberof EditFeatureRequest
     */
    featureName: EditFeatureRequestFeatureNameEnum;
    /**
     * 
     * @type {string}
     * @memberof EditFeatureRequest
     */
    targetId: string;
    /**
     * 
     * @type {Date}
     * @memberof EditFeatureRequest
     */
    validUntil?: Date | null;
}


/**
 * @export
 */
export const EditFeatureRequestFeatureNameEnum = {
    QwenModel: 'QwenModel',
    TokenLimit: 'TokenLimit'
} as const;
export type EditFeatureRequestFeatureNameEnum = typeof EditFeatureRequestFeatureNameEnum[keyof typeof EditFeatureRequestFeatureNameEnum];


/**
 * Check if a given object implements the EditFeatureRequest interface.
 */
export function instanceOfEditFeatureRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "featureName" in value;
    isInstance = isInstance && "targetId" in value;

    return isInstance;
}

export function EditFeatureRequestFromJSON(json: any): EditFeatureRequest {
    return EditFeatureRequestFromJSONTyped(json, false);
}

export function EditFeatureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditFeatureRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'featureName': json['featureName'],
        'targetId': json['targetId'],
        'validUntil': !exists(json, 'validUntil') ? undefined : (json['validUntil'] === null ? null : new Date(json['validUntil'])),
    };
}

export function EditFeatureRequestToJSON(value?: EditFeatureRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'featureName': value.featureName,
        'targetId': value.targetId,
        'validUntil': value.validUntil === undefined ? undefined : (value.validUntil === null ? null : value.validUntil.toISOString()),
    };
}

